export const isFree = (workspace) => workspace?.subscription.plan.code === 'free';
export const isTeam = (workspace) => workspace?.subscription.plan.code === 'team';
export const isAtLeastSolo = (workspace) => !isFree(workspace);
// Team is the highest tier today; the helper returns true once the workspace
// reaches it. The earlier `!isFree && !isTeam` was inverted — Team itself
// failed the check and Solo wrongly passed.
export const isAtLeastTeam = (workspace) => isTeam(workspace);
const ROLE_LEVEL = {
    OWNER: 100,
    ADMIN: 80,
    MANAGER: 50,
    MEMBER: 10,
};
export function isRoleAbove(role, other) {
    return ROLE_LEVEL[role] > ROLE_LEVEL[other];
}
export function isRoleAtLeast(role, other) {
    return ROLE_LEVEL[role] >= ROLE_LEVEL[other];
}
export function isRoleBelow(role, other) {
    return ROLE_LEVEL[role] < ROLE_LEVEL[other];
}
export function isRoleAtMost(role, other) {
    return ROLE_LEVEL[role] <= ROLE_LEVEL[other];
}
